import { cn } from "@/lib/utils";

interface Win2kButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export default function Win2kButton({
  children,
  className,
  disabled,
  ...props
}: Win2kButtonProps) {
  return (
    <button
      className={cn(
        "bg-[var(--win2k-button-face)] text-[var(--win2k-button-text)]",
        "px-4 py-1 text-xs font-bold min-h-[44px] md:min-h-[28px]",
        "cursor-default select-none",
        "focus-visible:outline-1 focus-visible:outline-dashed focus-visible:outline-offset-[-4px] focus-visible:outline-[var(--win2k-black)]",
        disabled
          ? "border-2 border-[var(--win2k-gray)] text-[var(--win2k-shadow)] shadow-none"
          : "win2k-outset active:win2k-inset active:pt-[6px] active:pb-[2px]",
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
